/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminTreasuryWalletsRow } from '../openapi-types.gen.js';
import { type useGetAdminTreasuryWalletsArgs, useGetAdminTreasuryWalletsSpec } from '../specs/admin.spec.gen.js';

export type { GetAdminTreasuryWalletsRow } from '../openapi-types.gen.js';
export type { useGetAdminTreasuryWalletsArgs } from '../specs/admin.spec.gen.js';


const _useGetAdminTreasuryWallets = createHook(useGetAdminTreasuryWalletsSpec);
export const useGetAdminTreasuryWallets = _useGetAdminTreasuryWallets as (args: useGetAdminTreasuryWalletsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminTreasuryWallets>;


/**
 * Hover/intent prefetch companion for `useGetAdminTreasuryWallets`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetAdminTreasuryWallets();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminTreasuryWallets = createPrefetchHook(useGetAdminTreasuryWalletsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminTreasuryWalletsArgs>;
